module.exports = __webpack_public_path__ + "static/media/fabric_board.5253c10f.png";